import { general_keywords } from '@/data/generalkeywords';
import { NextSeo } from 'next-seo';
import Head from 'next/head';

const BlogSEO = ({ title, shortDescription, keywords, slug, faqs, blogImages, datePublished, dateModified }) => {

  const blogTitle = title
  const blogDescription = shortDescription
  const blogKeywords = keywords || []
  const blogUrl = "https://yourcad.store/" + slug
  const blogImage = blogImages[0].url
  const alt = blogImages[0].description


  const formattedImages = blogImages.map((img) => ({
    "@type": "ImageObject",
    "url": img.url.replace(/ /g, "%20"), // Replaces spaces with %20
    "description": img.description
  }));
  


  return (
    <>
      <NextSeo
        title={"YourCad - " + blogTitle}
        description={blogDescription}
        canonical={`https://yourcad.store/blog/${slug}`}
        openGraph={{
          type: 'article',
          url: blogUrl,
          title: blogTitle,
          description: blogDescription,
          images: [
            {
              url: blogImage,
              width: 1200,
              height: 630,
              alt: alt,
            },
          ],
          site_name: 'YourCad',
        }}
        twitter={{
          cardType: 'summary_large_image',
          site: '@yourcad',
          handle: '@yourcad',
          title: blogTitle,
          description: blogDescription,
          image: blogImage,
        }}
        additionalMetaTags={[
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1',
          },
          { name: 'robots', content: 'index, follow' },
          { name: 'keywords', content: [...blogKeywords, ...general_keywords].join(', ') },
          { name: 'author', content: 'YourCad' },
          { name: 'language', content: 'EN' },
          { name: 'topic', content: title },
          { name: 'copyright', content: `YourCad © ${new Date().getFullYear()}` },
        ]}
      />

<Head>
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Article",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": blogUrl,
              "isPartOf": {
                "@type": "Website",
                "url": "https://yourcad.store"
              }
            },
            "headline": blogTitle,
            "image": formattedImages,
            "datePublished": datePublished,
            "dateModified": dateModified,
            "author": {
              "@type": "Person",
              "name": "YourCad"
            },
            "publisher": {
              "@type": "Organization",
              "name": "YourCad",
              "logo": {
                "@type": "ImageObject",
                "url": "https://yourcad.store/seoImg.webp"
              }
            },
            "description": blogDescription
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://yourcad.store/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://yourcad.store/blog"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": title,
                "item": `https://yourcad.store/blog/${slug}`
              }
            ]
          },
          ...(faqs ? [{
            "@type": "FAQPage",
            "mainEntity": faqs
          }] : [])
        ]
      })
    }}
  />
</Head>


    </>
  );
};

export default BlogSEO;













